import { DTOConstructor } from "./dto-constructor";

export class SessionDTO extends DTOConstructor<SessionDTO> {
    id: number;
    token: string;
    accountId: number;
    companyId?: number;
    scope: string;
}
